// extracted by mini-css-extract-plugin
export default {"myOrders":"MyOrdersTogether_myOrders__MSWcx","tabla":"MyOrdersTogether_tabla__6OnxZ"};